import { List } from 'immutable';
import createProperty from './create-property';

export default createProperty({
  default: () => [],
  validate(v) {
    return Array.isArray(v) || List.isList(v);
  },
});
